import { Action } from '@ngrx/store';

import { PreferenceSet } from '../../../scp/preferences/models';
import { HttpHeaders } from '@angular/common/http';

export enum PrefsSearchResultsActionTypes {
  LoadPrefsSearchResults = '[PrefsSearchResults] Load Search Results',
  LoadPrefsSearchResultsSuccess = '[PrefsSearchResults] Load Search Success',
  LoadPrefsSearchResultsFailure = '[PrefsSearchResults] Load Search Failure',
}

export class LoadPrefsSearchResults implements Action {
  readonly type = PrefsSearchResultsActionTypes.LoadPrefsSearchResults;
  constructor(public payload: number) { }
}

export class LoadPrefsSearchResultsSuccess implements Action {
  readonly type = PrefsSearchResultsActionTypes.LoadPrefsSearchResultsSuccess;
  constructor(public payload: PreferenceSet) { }
}

export class LoadPrefsSearchResultsFailure implements Action {
  readonly type = PrefsSearchResultsActionTypes.LoadPrefsSearchResultsFailure;
  constructor(public payload: any) { }
}

export type ReportPrefsSearchResultsActions =
  | LoadPrefsSearchResults
  | LoadPrefsSearchResultsSuccess
  | LoadPrefsSearchResultsFailure
